export const REF_INDEX: { [refOrder: string]: number } = {
  lastCardNumbersOrder: 4,
  lastSecurityCodeOrder: 8,
};
